/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GovForumArticle.vue?vue&type=template&id=dd0d25ec&scoped=true&"
import script from "./GovForumArticle.vue?vue&type=script&setup=true&lang=js&"
export * from "./GovForumArticle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./GovForumArticle.vue?vue&type=style&index=0&id=dd0d25ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0d25ec",
  null
  
)

export default component.exports